import { useEffect, useRef } from "react";
import { useNavigate } from "react-router";

import { setAccessToken } from "../../auth";
import { isUserSessionActive } from "../../auth/isUserSessionActive";
import { deleteCookieAccessToken, deleteCookieIdToken } from "../../auth/SecurityManager";
import { msalInstance } from "../../config/msalConfig";

interface ProtectedRouteProps {
    children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    // eslint-disable-next-line no-underscore-dangle
    const isMSEntraLogin = window.__RUNTIME_CONFIG__?.IDENTITY_SERVICE === "entra";
    const hasLoggedOut = useRef(false);
    const navigate = useNavigate();

    useEffect(() => {
        const validateSession = async () => {
            if (hasLoggedOut.current || !isMSEntraLogin) return;

            // First, check the session, after that token validity
            const tokenValid = await checkSession();
            const sessionActive = isUserSessionActive();

            if (!tokenValid || !sessionActive) {
                hasLoggedOut.current = true;
                softLogout();
            }
        };

        validateSession();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMSEntraLogin]);

    const checkSession = async (): Promise<boolean> => {
        try {
            const account = msalInstance.getAllAccounts()[0];
            if (!account) return false;

            const tokenResponse = await msalInstance.acquireTokenSilent({
                account,
                scopes: ["user.read"],
            });

            setAccessToken(tokenResponse.accessToken);
            return true;
        } catch {
            return false;
        }
    };

    const softLogout = () => {
        deleteCookieAccessToken();
        deleteCookieIdToken();
        navigate("/login", { replace: true });
    };

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
};
